import styled from 'styled-components';

export const Base = styled.div`
	box-sizing: border-box;

	// I had some sizing code that worked pretty well on Android, and may work on newer iPhones.
	// But it doesn't have compatibility with Safari 15.3 and earlier which apparently is 10-15% of the market.
	// width: 100%;
	// height: 100%; // fallback for older browsers (which don't support dvh)
	// height: 100dvh;
	// min-height: 0;
	// position: relative;

	// So instead I did this more oldschool approach. Which is working well so far.
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.gray['0']};
`;

export const Application = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: hidden;
`;

export const SceneNameRow = styled.div`
	padding: 0 16px;
	padding-bottom: 8px;
	border-bottom: 1px solid ${({ theme }) => theme.gray['200']};
`;

export const SceneName = styled.h2`
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray['1000']};
	margin: 0;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 200px;
	cursor: pointer;
	display: inline-block;
	padding: 8px 12px;
	border-radius: 6px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: ${({ theme }) => theme.gray['100']};
	}

	&:active {
		background-color: ${({ theme }) => theme.gray['200']};
	}
`;
//-----------------------------------------------------------------------------
// HEADER
//-----------------------------------------------------------------------------

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	padding: 0 16px;
	background: ${({ theme }) => theme.gray['0']};
	border-bottom: 1px solid ${({ theme }) => theme.gray['200']};
	flex-shrink: 0;
	z-index: 10;
`;

export const HeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex: 1;
	min-width: 0;
`;

export const ChatTitleButton = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	max-width: 220px;
	padding: 8px 12px;
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background: ${({ theme }) => theme.gray['100']};
	}

	&:active {
		background: ${({ theme }) => theme.gray['200']};
	}
`;

export const ChatTitle = styled.h1`
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray['1000']};
	margin: 0;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	flex: 1;
	min-width: 0;
`;

export const ChatTitleIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const HeaderRight = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const HeaderButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border: none;
	background: transparent;
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background: ${({ theme }) => theme.gray['100']};
	}

	&:active {
		background: ${({ theme }) => theme.gray['200']};
	}
`;

export const MoreButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border: none;
	background: transparent;
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background: ${({ theme }) => theme.gray['100']};
	}

	&:active {
		background: ${({ theme }) => theme.gray['200']};
	}
`;

export const InnerWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const MoreButtonLogo = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

//-----------------------------------------------------------------------------
// MAIN CONTENT
//-----------------------------------------------------------------------------

export const MainContent = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
	overflow: hidden;
`;

// Placeholder Styles
export const Placeholder = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	text-align: center;
`;

export const PlaceholderIcon = styled.div`
	margin-bottom: 16px;
`;

export const PlaceholderTitle = styled.h3`
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray['1000']};
	margin: 0 0 8px 0;
`;

export const PlaceholderDescription = styled.p`
	font-size: 16px;
	color: ${({ theme }) => theme.gray['600']};
	margin: 0;
	line-height: 1.5;
`;
